export const PRODUCT = 'product'
export const TICKET = 'ticket'
export const SUBSCRIPTION = 'subscription'
